import axios from "axios";
import { getEnvVars } from "../Environment";
import openNotification from "../helpers/notification.helper";

const { apiUrl } = getEnvVars();
// console.log("apiUrl", apiUrl);

axios.interceptors.request.use(
  (request: any) => {
    request.baseURL = apiUrl; //product =>   https://api.aassttiinn.org

    const apiToken = localStorage.getItem("access_token");
    // console.log("apiToken", apiToken);
    if (apiToken) {
      request.headers["Authorization"] = "Bearer " + apiToken;
    } else {
      request.headers["Authorization"] = "darivvary";
    }
    console.log(request.url, " : ", request);

    return request;
  },
  (error) => {
    console.log("error inspectro use request");
    return Promise.reject(error);
    // throw error;
  }
);

axios.interceptors.response.use(
  (response: any) => {
    if (response.headers["content-type"] === "application/json; charset=utf-8" ) {
      if (response.status !== 200 && response.status !== 204) {
        console.log("302 url", response.request.responseURL);
      }

      // console.log("response", response); undefindeu ==>error
      return response;
    } else {
      return response;
      // openNotification("توکن نامعتبر - در حال خروج از سایت ... ", "error");
      // // window.localStorage.clear(); //clear all localstorage
      // // setTimeout(() => {
      // //   window.location.href = "/";
      // // }, 1500);
    }
  },
  async function (error) {
    console.log("error 22", error.message);
    openNotification(error.message, "error");
    // NotificationManager.error('لطفا مجددا تلاش کنید')
  }
);

// export default WmsApi;

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};

// <<<<<<< HEAD
// =======

// >>>>>>> develop
//windoww
//  "start": "set PORT=4200 && react-scripts start",
